import { Injectable } from '@angular/core';

type QueryErrorMessages = {
  EMPTY_RESPONSE: string;
  MIN_LENGTH: string;
};

@Injectable({
  providedIn: 'root',
})

export class ReAcquisitionHelper {
  
  readonly MIN_QUERY_LENGTH = 9;
  readonly ERROR_MESSAGES: Record<string, QueryErrorMessages> = {
    en: {
      EMPTY_RESPONSE: "This field is required — let the doctor know your concern.",
      MIN_LENGTH: "Your message must be at least 10 characters to help the doctor understand your concern."
    },
    hi: {
      EMPTY_RESPONSE: "यह जानकारी ज़रूरी है — डॉक्टर को अपनी समस्या बताएं।",
      MIN_LENGTH: "डॉक्टर को आपकी समस्या समझने में मदद के लिए कम से कम 10 अक्षर लिखें।"
    },
    mr: {
      EMPTY_RESPONSE: "ही माहिती आवश्यक आहे — डॉक्टरांना तुमची समस्या सांगा.",
      MIN_LENGTH: "डॉक्टरांना तुमची समस्या समजण्यासाठी किमान 10 अक्षरे लिहा."
    },
    te: {
      EMPTY_RESPONSE: "ఈ సమాచారం తప్పనిసరి — మీ సమస్యను డాక్టర్‌కు చెప్పండి.",
      MIN_LENGTH: "డాక్టర్‌కు మీ సమస్య అర్థం కావడానికి కనీసం 10 అక్షరాలు రాయండి."
    },
    ta: {
      EMPTY_RESPONSE: "இந்த தகவல் அவசியம் — உங்கள் பிரச்சனையை மருத்துவரிடம் சொல்லுங்கள்.",
      MIN_LENGTH: "மருத்துவர் உங்கள் பிரச்சனையைப் புரிந்துகொள்ள குறைந்தது 10 எழுத்துகள் எழுதுங்கள்."
    },
    kn: {
      EMPTY_RESPONSE: "ಈ ಮಾಹಿತಿ ಅಗತ್ಯ — ನಿಮ್ಮ ಸಮಸ್ಯೆಯನ್ನು ಡಾಕ್ಟರ್‌ಗೆ ತಿಳಿಸಿ.",
      MIN_LENGTH: "ಡಾಕ್ಟರ್‌ಗೆ ನಿಮ್ಮ ಸಮಸ್ಯೆ ಅರ್ಥವಾಗಲು ಕನಿಷ್ಠ 10 ಅಕ್ಷರಗಳನ್ನು ಬರೆಯಿರಿ."
    },
    bn: {
      EMPTY_RESPONSE: "এই তথ্যটি জরুরি — ডাক্তারকে আপনার সমস্যার কথা জানান।",
      MIN_LENGTH: "ডাক্তারকে আপনার সমস্যা বুঝতে সাহায্য করতে অন্তত ১০টি অক্ষর লিখুন।"
    }
  };

  constructor() {}

  validateUserQuery(userQuery: string, userLanguagePreference?: string): { valid: boolean; error: string } {
    const language = userLanguagePreference || 'en';
    const errorMessages = this.ERROR_MESSAGES[language] || this.ERROR_MESSAGES.en;

    if (!userQuery?.length) {
      return { valid: false, error: errorMessages.EMPTY_RESPONSE };
    }
    if (userQuery.length <= this.MIN_QUERY_LENGTH) {
      return { valid: false, error: errorMessages.MIN_LENGTH };
    }
    return { valid: true, error: '' };
  }
}
